
/* Fills the thumbnail rail and keeps it in step with the face selector. */
(function(){
var P=window.IF_DESIGNS||[];
var rail=document.getElementById('if-thumbs');
if(!rail||!P.length)return;

function current(){
var h=document.getElementById('if-name');
var nm=h?(h.textContent||'').trim():'';
for(var i=0;i<P.length;i++)if(P[i].name===nm)return P[i].id;
return P[0].id;
}

function pick(id){
var u=document.getElementById('if-units');
if(!u||!u.children[0])return;
var t=null;
for(var i=0;i<P.length;i++)if(P[i].id===id)t=P[i];
if(!t)return;
var btns=u.children[0].querySelectorAll('button');
for(var k=0;k<btns.length;k++){
if(btns[k].getAttribute('title')===t.name){btns[k].click();return;}
}
}

function paint(){
var cur=current();
if(rail.getAttribute('data-cur')===cur&&rail.children.length)return;
rail.setAttribute('data-cur',cur);
rail.innerHTML='';
P.forEach(function(p){
var on=p.id===cur;
var b=document.createElement('button');
b.type='button';
b.title=p.name;
b.setAttribute('style','flex:0 0 auto; width:64px; height:64px; padding:0; border-radius:10px; overflow:hidden; cursor:pointer; background:#EFF1F4; border:2px solid '+(on?'#12161C':'#E3E7EC')+';');
b.innerHTML='<img src="'+p.img+'" alt="'+p.name+'" loading="lazy" style="width:100%; height:100%; object-fit:cover; display:block; pointer-events:none;">';
b.onclick=function(){pick(p.id);setTimeout(paint,90);};
rail.appendChild(b);
});
}

paint();
setInterval(paint,700);
})();
